var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBottle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 175,
    viewBox: "0 0 50 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3549 93.1529C47.5995 86.1311 45.5873 83.3872 40.3748 74.8682C32.75 62.4075 32.9052 42.8272 32.9052 42.8272V3.12282C32.9052 1.39946 29.3645 0 24.9998 0C20.6351 0 17.0944 1.39946 17.0944 3.12282V42.8333C17.0944 42.8333 17.2496 62.4197 9.62482 74.8743C4.41226 83.3933 2.40605 86.1372 0.644646 93.159C-0.0718573 96.019 -0.000206978 99.374 -0.000206978 99.374V165.118C-0.000206978 170.576 11.1892 175 24.9998 175C38.8104 175 49.9998 170.576 49.9998 165.118V99.374C49.9998 99.374 50.0714 96.019 49.3549 93.1529Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_1179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 175,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBottle);
export default __webpack_public_path__ + "static/media/EmptyBottle.231b9e60baccd222806d79bb67904b63.svg";
export { ForwardRef as ReactComponent };